import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Drawer, Tooltip } from "@renderbus/ui";
import { useState } from "react";
import GiftIcon from "@/assets/icons/topup/gift";
import CongratulateIcon from "@/assets/icons/topup/congratulate";
import { RightOutlined } from "@ant-design/icons";
import { QrcodeType, TicketType, ModalPage } from "../constants/cash-status";
import { AssistantQrcode } from "./assistant-qrcode";
import { TicketCard } from "./ticket-card";
import { useFetchLotteryActivityInfoList } from "../hooks/useFetchLotteryActivityInfoList";
import ClockIcon from "@/assets/icons/topup/clock";
import {
  getCashPrizeStatus,
  getCashPrizeTime,
  getCashPrizeSubContent,
  getCashPrizeType,
} from "../helper/index";
import { useLotteryStore } from "../store/lottery-store";
import { Typography } from "antd";
import WarnIcon from "@/assets/icons/topup/warn";
import { useGlobalStore } from "@/store/GlobalStore";
import { isDev } from "project-config/utils/env";
import Loading from "@/components/Loading";
import ActivityInfoStoreProvider, {
  useActivityInfoStore,
} from "../store/activity-info-store";
import VideoQrcodeImg from "@/assets/images/video-qrcode.png";
const { Paragraph } = Typography;

export function TicketBoxView({ onCloseModal }: { onCloseModal: () => void }) {
  const { t } = useTranslation("topup");
  const { isZh } = useGlobalStore();
  const [openDrawer, setOpenDrawer] = useState(false);
  const {
    lotteryActivityInfoList,
    showCashActivityEntry,
    lottryActivityRules,
    luckDrawGiftActivityInfo,
    loading,
  } = useFetchLotteryActivityInfoList();
  const isAlreadyRecharge =
    !!lotteryActivityInfoList.length || showCashActivityEntry; // 已经充值
  const { content, subTitle, status, fields, isDate } = getCashPrizeStatus(
    showCashActivityEntry,
    lotteryActivityInfoList[0]
  );
  const { rulesContentList } = useActivityInfoStore();
  const { setCurrentModalPage } = useLotteryStore();

  const currentRulesContentList = rulesContentList(luckDrawGiftActivityInfo)
    ? rulesContentList(luckDrawGiftActivityInfo)
    : lottryActivityRules[isZh ? "rulesCN" : "rulesEN"]?.split("\n");

  const isBeginCashPrize = lotteryActivityInfoList.find(
    (item) => item.startTime && item.startTime <= +new Date()
  );
  const isEndCashPrize = lotteryActivityInfoList.find(
    (item) => item.endTime && item.endTime <= +new Date()
  );
  const isWinPrize = !lotteryActivityInfoList.every((item) => !item.prizeType);

  const handleOperateLottery = () => {
    if (
      lotteryActivityInfoList && lotteryActivityInfoList.length
        ? lotteryActivityInfoList[0].remark
        : false
    )
      return;
    if (isEndCashPrize) return;
    if (showCashActivityEntry) {
      setCurrentModalPage(ModalPage.CashInformationPage);
      return;
    }
    onCloseModal();
    const basename =
      process.env.NODE_ENV === "development" ? "/topUp" : "/center/user/topUp";
    window.open(basename, "_blank");
  };

  const getPrizeCodeText = (data: { startTime: number; prizeType: number }) => {
    const { startTime, prizeType } = data;
    if (!startTime) return;
    if (!isWinPrize) {
      return t("topup_lottery_win_join_prize");
    }
    if (!prizeType) return;
    return getCashPrizeType(prizeType, isZh).toString();
  };

  return (
    <LotteryModalWrapper isBeginCash={!!isBeginCashPrize}>
      <LotteryHeader>
        <div>
          {luckDrawGiftActivityInfo ? (
            <>
              {t("topup_lottery_get_time")}
              <span>{`${getCashPrizeTime(
                "startDate",
                luckDrawGiftActivityInfo
              )}-${getCashPrizeTime(
                "endDate",
                luckDrawGiftActivityInfo
              )}`}</span>
            </>
          ) : (
            <>
              <ClockIcon />
              <span className={"activity-end"}>
                {t("topup_lottery_has_ended")}
              </span>
            </>
          )}
        </div>
        <div onClick={() => setOpenDrawer(true)}>{t("vip_activity_rules")}</div>
      </LotteryHeader>
      <LotteryContent
        borderColor={
          isBeginCashPrize ? (isWinPrize ? "#FF4133" : "#F99520") : ""
        }
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <div className={"prize-code"}>
              {!isAlreadyRecharge ? (
                !luckDrawGiftActivityInfo && !isBeginCashPrize ? (
                  <div className={"not-recharge"}>
                    {t("topup_lottery_prize_no_record")}
                  </div>
                ) : (
                  <div className={"not-recharge"}>
                    {t("topup_lottery_not_got_ticket")}
                    <span
                      className={"green"}
                      onClick={() => handleOperateLottery()}
                    >
                      {t("topup_lottery_recharge")}
                    </span>
                  </div>
                )
              ) : (
                lotteryActivityInfoList.map((item) => {
                  return (
                    <TicketCard
                      isActive={
                        !(item.startTime && item.startTime <= +new Date())
                      }
                      key={item.ticketCode}
                      type={
                        item.startTime
                          ? item.prizeType
                            ? TicketType.WinPrize
                            : TicketType.NoWinPrize
                          : TicketType.NoCash
                      }
                      number={item.ticketCode}
                      prizeCardText={getPrizeCodeText(item)}
                    />
                  );
                })
              )}
            </div>
            {luckDrawGiftActivityInfo &&
              Number(
                luckDrawGiftActivityInfo?.activityDetail[0].surveyLotteryCount
              ) > 0 &&
              Boolean(lotteryActivityInfoList.length) &&
              Boolean(
                !lotteryActivityInfoList.filter((item) => !item.payRecordId)
                  .length
              ) && (
                <LotteryContentFooter>
                  <GiftIcon fill={"#FE4E3F"} />
                  {t("topup_lottery_questionnaire_tip", {
                    num: luckDrawGiftActivityInfo?.activityDetail[0]
                      .surveyLotteryCount,
                  })}
                  &nbsp;&nbsp;
                  <span
                    className={"green"}
                    onClick={() =>
                      window.open(
                        `${
                          isDev()
                            ? "http://pre.renderbus.com:8081"
                            : "https://www.renderbus.com"
                        }/nvidia-form.html?activityId=${
                          luckDrawGiftActivityInfo.id
                        }`
                      )
                    }
                  >
                    {t("topup_lottery_fill_in")}
                  </span>{" "}
                  <RightOutlined />
                </LotteryContentFooter>
              )}
            {!luckDrawGiftActivityInfo && !isBeginCashPrize && (
              <LotteryContentFooter>
                {t("topup_lottery_prize_end")}
              </LotteryContentFooter>
            )}
            {!luckDrawGiftActivityInfo && isBeginCashPrize && (
              <LotteryCashResultTip isWinPrize={isWinPrize}>
                <CongratulateIcon />
                {t("topup_lottery_win_prize", {
                  prize: isWinPrize
                    ? getCashPrizeType(
                        lotteryActivityInfoList[0]
                          ? lotteryActivityInfoList[0].prizeType
                          : "",
                        isZh,
                        lotteryActivityInfoList
                      )
                    : t("topup_lottery_win_join_prize"),
                })}
              </LotteryCashResultTip>
            )}
          </>
        )}
      </LotteryContent>
      <LotteryFooter
        hiddenColumnGap={!!(luckDrawGiftActivityInfo || isBeginCashPrize)}
      >
        {(luckDrawGiftActivityInfo || isBeginCashPrize) && (
          <LotteryFooterEdit data-before={t(status)} isFillReceiving={!!status}>
            <span>
              {t(
                showCashActivityEntry
                  ? "topup_lottery_fill_information_tip"
                  : "topup_lottery_single_recharge",
                {
                  num: luckDrawGiftActivityInfo?.activityDetail[0].amount,
                  lotteryNum:
                    luckDrawGiftActivityInfo?.activityDetail[0].lotteryCount,
                }
              )}
            </span>
            <LotteryCashInformation
              onClick={() => handleOperateLottery()}
              isDuringActivity={!!luckDrawGiftActivityInfo}
              isExpired={
                !!(
                  (lotteryActivityInfoList && lotteryActivityInfoList.length
                    ? lotteryActivityInfoList[0].remark
                    : false) || isEndCashPrize
                )
              }
            >
              <div className="lottery-cashtext">{t(content)}</div>
              {subTitle && (
                <div className={"cash-subcontent"}>
                  {status === "topup_lottery_expired" && <WarnIcon />}
                  {t(subTitle)}
                  {fields !== "remark" &&
                    getCashPrizeSubContent(
                      fields,
                      isDate,
                      lotteryActivityInfoList[0]
                    )}
                </div>
              )}
              {fields === "remark" &&
                getCashPrizeSubContent(
                  fields,
                  isDate,
                  lotteryActivityInfoList[0]
                ) && (
                  <div className={"cash-remark"}>
                    {getCashPrizeSubContent(
                      fields,
                      isDate,
                      lotteryActivityInfoList[0]
                    )}
                    <RenderbusParagraph
                      copyable={{
                        text: getCashPrizeSubContent(
                          fields,
                          isDate,
                          lotteryActivityInfoList[0]
                        ).toString(),
                      }}
                    />
                  </div>
                )}
            </LotteryCashInformation>
          </LotteryFooterEdit>
        )}
        {!isBeginCashPrize && (
          <div>
            <span>{t("topup_lottery_lottery_process")}</span>
            <LotteryCashBili isDuringActivity={!!luckDrawGiftActivityInfo}>
              <Tooltip
                color="rgba(0, 0, 0, 0.8)"
                placement="topLeft"
                title={
                  <img
                    src={VideoQrcodeImg}
                    alt=""
                    style={{ height: "124px", padding: "2px 4px 0" }}
                  />
                }
                tooltipText={<img src={VideoQrcodeImg} alt="" />}
              />
              <span>{t("topup_lottery_video_search")}</span>
            </LotteryCashBili>
          </div>
        )}
        <div>
          {!isBeginCashPrize && <span>{t("topup_lottery_little_helper")}</span>}
          <AssistantQrcode
            type={
              isBeginCashPrize
                ? QrcodeType.CashPrize
                : QrcodeType.ActivityRecharge
            }
          />
        </div>
      </LotteryFooter>
      <Drawer
        width={480}
        open={openDrawer}
        title={t("vip_activity_rules")}
        onClose={() => setOpenDrawer(false)}
        drawerContent={
          currentRulesContentList && (
            <TicketModalRules>
              {currentRulesContentList?.map((item) => {
                return <p key={item}>{item}</p>;
              })}
            </TicketModalRules>
          )
        }
      />
    </LotteryModalWrapper>
  );
}

export function TicketBox(props: { onCloseModal: () => void }) {
  return (
    <ActivityInfoStoreProvider>
      <TicketBoxView {...props} />
    </ActivityInfoStoreProvider>
  );
}

const RenderbusParagraph = styled(Paragraph)`
  &.ant-typography {
    margin-bottom: 0;
  }
  .ant-typography-copy {
    color: #9ba2b0;
    svg {
      width: 10px;
      height: 10px;
    }
  }
`;

const TicketModalRules = styled.div`
  padding: 30px 16px 0 24px;
  p {
    color: #e0e1e1;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    padding-bottom: 4px;
  }
`;
const LotteryContentFooter = styled.div`
  position: sticky;
  bottom: -1px;
  background: #17191c;
  width: 778px;
  padding: 6px 14px;
  left: 0;
  display: flex;
  align-items: center;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  color: #ffffff;
  svg {
    color: var(--main-color);
    margin-left: 6px;
  }
  .green {
    cursor: pointer;
  }
`;
const LotteryFooterCard = styled.div`
  height: 79px;
  background: #232528;
  border: 1px solid #404246;
  border-radius: 4px;
  margin-top: 6px;
  display: flex;
  align-items: center;
  display: flex;
`;
const LotteryCashInformation = styled(LotteryFooterCard)<{
  isDuringActivity: boolean;
  isExpired: boolean;
}>`
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  padding: 0 28px;
  cursor: ${(props) => !props.isExpired && "pointer"};
  flex-direction: column;
  margin-right: ${(props) => props.isDuringActivity && "30px"};
`;
const LotteryCashBili = styled(LotteryFooterCard)<{
  isDuringActivity: boolean;
}>`
  padding-left: 8px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  padding-right: 48px;
  margin-right: ${(props) => props.isDuringActivity && "30px"};
  img {
    height: 60px;
    padding-right: 14px;
  }
`;

const LotteryModalWrapper = styled.div<{ isBeginCash: boolean }>`
  background: #343538;
  padding: 0 10px 14px;
  .not-recharge {
    font-size: 16px;
    line-height: 22px;
    color: #bfc2c3;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 138px auto auto;
  }
  .green {
    color: var(--main-color);
    cursor: pointer;
  }
  svg {
    margin-right: 8px;
  }
  .prize-code {
    padding: 20px 20px 0;
    display: flex;
    flex-wrap: wrap;
    min-height: ${(props) => (props.isBeginCash ? "220px" : "246px")};
    border-radius: 4px;
    align-content: flex-start;
  }
  .activity-end {
    font-weight: 600;
    font-size: 18px;
    color: #edf7fa;
    padding-left: 0;
  }
  .cash-subcontent {
    font-weight: 600;
    font-size: 14px;
    line-height: 22px;
    color: #9faeb3;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
  }
  .cash-remark {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #edf6f9;
    display: flex;
  }
`;
const LotteryHeader = styled.div`
  font-weight: 600;
  line-height: 20px;
  color: #c7d1d4;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  span {
    font-weight: 400;
    padding-left: 12px;
  }
  div:nth-child(1) {
    align-items: center;
    display: flex;
  }
  div:nth-child(2) {
    color: var(--main-color);
    cursor: pointer;
    font-weight: 400;
  }
`;
const LotteryFooterEdit = styled.div<{ isFillReceiving: boolean }>`
  position: relative;
  flex: 1;
  &::before {
    content: attr(data-before);
    position: absolute;
    background: ${(props) =>
      props.isFillReceiving &&
      "linear-gradient(89.9deg, rgba(19, 203, 122, 0.31) 0.08%, rgba(19, 203, 121, 0) 88.05%)"};
    font-weight: 600;
    font-size: 12px;
    top: 29px;
    border-top-left-radius: 4px;
    padding-left: 8px;
    padding-top: 4px;
    height: 24px;
    min-width: 102px;
  }
`;
const LotteryContent = styled.div<{ borderColor: string }>`
  background: #232528;
  border: 1px solid #404246;
  border-radius: 4px;
  width: 806px;
  height: 300px;
  margin-bottom: 40px;
  align-content: flex-start;
  position: relative;
  overflow: auto;
  border: ${(props) => `1px solid ${props.borderColor || "rgb(35, 37, 40)"}`};
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    background-color: transparent;
    z-index: 9999; /* 确保滚动条位于其他元素上方 */
  }
`;
const LotteryFooter = styled.div<{ hiddenColumnGap: boolean }>`
  display: flex;
  color: #c7d1d4;
  column-gap: ${(props) => !props.hiddenColumnGap && "24px"};
  .lottery-cashtext {
    background: var(--task-user-icon-background);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
`;
const LotteryCashResultTip = styled(LotteryContentFooter)<{
  isWinPrize: boolean;
}>`
  background: ${(props) =>
    props.isWinPrize
      ? "linear-gradient(98.16deg, #FD6A4A 2.09%, #FF3D31 98.11%)"
      : "#F99520"};
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #edf6f9;
  height: 48px;
  justify-content: center;
`;
